import midAutumn from '@/views/act/midAutumnAccum2026/assets/locales/vi.js'
import halloween from '@/views/act/halloween/assets/locale/vi.js'
export default {
  midAutumn,
  halloween,
  "props": {
    "90501249": "Danh Hiệu – Trăng Rằm Trung Thu",
    "10101048": "Groza - Angel's Dream (7 ngày)",
    "10101059": "M762 - Cửu Vĩ Hồ (7 ngày)",
    "70100004": "Vé Điểm",
    "70100101": "Kim Cương",
    "80102101": "Vé quay Kim Cương",
    "80202003": "Thẻ nâng cấp vũ khí c3",
    "1010504001": "P90 - Thiết Liên Hoa (5 ngày)",
    "80103001": "Thẻ Bảo Vệ Xếp Hạng",
    "80103002": "Thẻ Nhân Đôi Điểm Xếp Hạng",
    "70100011": "Xu Vàng",
    "70100014": "Chìa khóa Bí Bảo",
    "81010999": "Xu phát triển vạn năng",
    "70100013": "Vé Bí Bảo",
    "50120500": "Ao hồ ngày hè",
    "90301912": "[Khung Avatar] Đẳng Cấp Đại Gia",
    "90501246": "[Danh hiệu] Đẳng Cấp Đại Gia",
    "90301913": "[Khung Avatar] Siêu Đại Gia",
    "90501247": "[Danh hiệu] Siêu Đại Gia",
    "90301914": "[Khung Avatar] Đại Gia",
    "90501248": "[Danh hiệu] Đại Gia",
    "70100012": "Đá Bí Bảo",
    "32701009": "Gói trang bị đầy đủ cao cấp"
  },
  "payment": {
    "popupEvent": {
      "joinImmediate": "Tham gia ngay",
      "noMoreTip": "Không nhắc lại hôm nay"
    },
    "videoIntro": "KCSM là đơn vị tiền tệ dùng chung trong game, có thể được sử dụng để thanh toán trực tiếp khi mua bất kỳ gói trả phí nào trong trò chơi mà không cần thanh toán thêm bằng tiền mặt.\n\nGiá trị của KCSM hoàn toàn tương đương với hình thức thanh toán bằng tiền mặt trong game. Khi nạp KCSM, người chơi sẽ nhận được ưu đãi tặng thêm theo từng gói nạp.\n\nVí dụ: Một gói trong game có giá khoảng 249.000 VND có thể được mua bằng KCSM có giá trị tương đương khoảng 249.000 VND. Khi nạp KCSM trị giá khoảng 249.000 VND, người chơi sẽ được tặng thêm 10% KCSM.\n\nLưu ý: Với lần nạp KCSM đầu tiên, người chơi có thể nhận ưu đãi tặng thêm lên đến 100% KCSM.",
    "post": {
      "title": "Thông tin thêm",
      "announcement": "Thông báo",
      "faq": "Câu hỏi thường gặp"
    },
    "howToCheckUserId": "Cách xem UID",
    "title": "Nạp chính thức, quà thơm phức!",
    "noData": "Không có dữ liệu",
    "tip": "Nhắc nhở",
    "notStart": "Sự kiện chưa bắt đầu.",
    "ended": "Kết thúc",
    "maintainTip": "Kênh thanh toán này đang được bảo trì. Vui lòng thử lại sau.",
    "validateUser": {
      "title": "Xác minh tài khoản",
      "enterUserId": "Nhập ID nhân vật",
      "desc": "ID nhân vật",
      "submit": "Xác Nhận",
      "noUserText": "Hãy kiểm tra và xác nhận thông tin người dùng trước",
      "queryLimitExceeded": "Kiểm tra quá nhiều lần, hãy thử lại sau",
      "userNotFound": "ID không tồn tại. Vui lòng kiểm tra và nhập lại. (Nhấn dấu hỏi để xem hướng dẫn tìm ID)"
    },
    "userDialog": {
      "id": "ID nhân vật",
      "name": "Tên nhân vật",
      "confirmText": "Xác nhận thông tin tài khoản của bạn",
      "confirmInput": "Xác Nhận",
      "cancelInput": "Nhập lại"
    },
    "payStatusDialog": {
      "cancelText": "Xác Nhận",
      "paySuccess": "Nạp tiền hoàn tất!",
      "payFailed": "Nạp thất bại",
      "paying": "Đang kiểm tra"
    },
    "mallGuideDialog": {
      "title": "Nạp tiền thành công",
      "desc": "Bạn đã hoàn tất việc nạp KCSM. Hãy đến Cửa hàng Thành viên ngay để nhận phần thưởng của bạn!",
      "claimLater": "Nhận sau",
      "goNow": "Đi ngay"
    },
    "paymentMethod": {
      "title": "Chọn phương thức thanh toán",
      "recommend": "Đề xuất",
      "moreMethod": "Phương thức thanh toán khác",
      "confirm": "Xác Nhận",
      "diankaTip1": "Lưu ý: 1 KCSM = 250 VND. Sau khi nạp thành công, KCSM sẽ được gửi thẳng tới tài khoản của bạn, tương ứng theo mệnh giá thẻ nạp bạn lựa chọn.",
      "diankaTip2": "Vui lòng chọn đúng mệnh giá thẻ nạp của bạn. Nếu chọn sai mệnh giá, bạn sẽ không thể lấy lại được phần chênh lệch. Trang này chỉ cung cấp dịch vụ thanh toán và sẽ không chịu trách nhiệm bồi hoàn khi người chơi chọn sai mệnh giá."
    },
    "product": {
      "title": "Chọn Gói Nạp",
      "gift-single": "Tặng",
      "gift": "Tặng thêm",
      "giftRegular": "Tặng thường",
      "giftActivity": "Người dùng mới nhận thêm",
      "giftActivityBadge": "Người dùng mới nhận thêm {num}",
      "giftRegularBadge": "+{num} KCSM",
      "giftPointsBadge": "+{num} Điểm",
      "coinTotal": "Tổng cộng {total} ({coin}+{gift})",
      "coinTotalOnly": "Tổng cộng {total}",
      "remaining": "Còn lại {num} lượt",
      "points": "Điểm",
      "summary": "Thông tin giao dịch",
      "selected": "Gói được chọn",
      "diamond": "KCSM",
      "total": "Tổng",
      "confirm": "Xác Nhận",
      "limit": "Lượt mua còn lại"
    }
  },
  "header": {
    "memberStore": "Cửa Hàng Thành Viên"
  },
  "tabbar": {
    "recharge": "Nạp",
    "pointsMall": "Cửa hàng điểm"
  },
  "footer": {
    "link": {
      "privacy": "Thỏa thuận cấp phép trò chơi và dịch vụ",
      "security": "Chính sách bảo mật"
    },
    "jumpLink": {
      "fb": "https://www.facebook.com/miniworldroyalevn",
      "fbGroup": "https://www.facebook.com/groups/mwrvn",
      "dc": "https://discord.gg/Eqje65WBpf",
      "yt": "https://www.youtube.com/{'@'}MiniWorldRoyaleOfficial/featured",
      "tt": "https://www.tiktok.com/{'@'}miniworldroyale.vn",
      "privacy": "https://www.miniworldroyale.com/vi/terms/17",
      "security": "https://www.miniworldroyale.com/vi/terms/16"
    },
    "text": "Nếu gặp vấn đề khi thanh toán, vui lòng liên hệ CSKH qua email: ministarcustomerservice{'@'}gmail.com để được hỗ trợ"
  },
  "customerServiceText": "Vui lòng liên hệ với chúng tôi qua email ministarcustomerservice{'@'}gmail.com",
  "cancelText": "Quay lại",
  "api": {
    "networkError": "Lỗi mạng",
    "serverError": "Lỗi máy chủ, mã lỗi:"
  },
  "poolParty": {
    "box1": "Rương Hiếm",
    "box2": "Rương Cao Cấp",
    "loginDialog": {
      "title": "Xác minh nhân vật để nhận Quà Chào Mừng."
    },
    "prop": {
      "ACTIVITY_SWIM_RING": "Phao bơi",
      "ACTIVITY_WATER_GUN": "Súng nước",
      "ACTIVITY_SUN_UMBRELLA": "Ô che nắng",
      "ACTIVITY_SWIM_GOGGLES": "Kính bơi",
      "80202003": "Thẻ nâng cấp vũ khí c3",
      "70100101": "Kim Cương",
      "80102101": "Vé quay Kim Cương",
      "80102004": "Phiếu giảm giá Vé Điểm",
      "80103001": "Thẻ Bảo Vệ Xếp Hạng",
      "80103002": "Thẻ Nhân Đôi Điểm Xếp Hạng",
      "70100011": "Xu Vàng",
      "70100014": "Chìa khóa Bí Bảo",
      "70100013": "Vé Bí Bảo",
      "81010999": "Xu phát triển vạn năng",
      "90301907": "[Giới hạn] Khung Avatar - Tiệc Bể Bơi"
    },
    "record": {
      "title": "Lịch Sử",
      "detailTitle": "Chi tiết phần thưởng",
      "dateTitle": "Thời gian nhận",
      "noData": "Không có dữ liệu"
    },
    "btnCanReceive": "Còn sẵn",
    "btnReceived": "Đã nhận",
    "btnNotReach": "Chưa đạt mốc",
    "goRecharge": "Tới Trang Nạp",
    "welcomeReward": {
      "title": "Quà Chào Mừng",
      "desc": "Hoàn tất xác minh nhân vật để nhận."
    },
    "exchange": {
      "desc1": "Thu thập đủ tất cả vật phẩm Tiệc Bể Bơi để nhận miễn phí phần thưởng giới hạn: Khung Avatar - Tiệc Bể Bơi.",
      "desc2": "Trong thời gian sự kiện, khi tổng Kim Cương nạp đạt 1000/2000/3000, bạn có thể nhận thêm 1 vật phẩm Tiệc Bể Bơi chưa sở hữu.",
      "mainPropName": "[Giới hạn] Khung Avatar - Tiệc Bể Bơi"
    },
    "dailyReward": {
      "day": "Ngày {day}",
      "desc": "Mở khóa 1 rương sau lần nạp Kim Cương đầu tiên mỗi ngày."
    },
    "accumReward": {
      "itemTitle": "Thưởng Tiệc Bể Bơi",
      "itemCountText": "Nạp tích luỹ KCSM đạt mốc {need} ({current}/{need})",
      "randomProp": "(Random) Vật phẩm Tiệc Bể Bơi",
      "randomPropNotOwned": "(Random) Vật phẩm Tiệc Bể Bơi chưa nhận"
    },
    "rule": {
      "item1": "Trong thời gian SK, mỗi ngày sau lần nạp KCSM đầu tiên sẽ nhận được 1 Rương Hiếm chứa vật phẩm trong game và 1 vật phẩm Tiệc Bể Bơi độc quyền.",
      "item2": "Sự kiện Tiệc Bể Bơi có 4 vật phẩm: Phao bơi, Súng nước, Ô che nắng và Kính bơi (chỉ sử dụng trong sự kiện Tiệc Bể Bơi). Thu thập đủ 4 vật phẩm khác nhau để nhận phần thưởng giới hạn [Khung Avatar - Tiệc Bể Bơi].",
      "item3": "Rương thứ 3 và thứ 7 là Rương Cao Cấp, chứa nhiều vật phẩm trong game hơn và chắc chắn nhận được 1 vật phẩm Tiệc Bể Bơi mà bạn chưa sở hữu.",
      "item4": "Trong thời gian sự kiện, khi tổng KCSM nạp đạt 1000/2000/3000, bạn sẽ mở khóa thêm Gói Tiệc Bể Bơi. Mở gói chắc chắn nhận được 1 vật phẩm Tiệc Bể Bơi chưa sở hữu.",
      "item5": "BTC có quyền quyết định và giải thích cuối cùng đối với sự kiện này.",
      "item6": ""
    }
  },
  "accumRecharge": {
    "countDownTitle": "Đếm ngược sự kiện bắt đầu",
    "countFuhao": " - SL: ",
    "clickHere": "Nhấn vào đây",
    "introduce": "Truy cập trang nạp [clickHere], nạp chính xác các gói 500/1000/2500/5000/10000 KCSM, sẽ nhận được phần thưởng tương ứng bên dưới.\nThời gian sự kiện: 23:00, 18/9/2025 ~ 22:59, 06/10/2025 (GMT+7)\nHạn cuối để nhận thưởng: 22:59, 12/10/2025 (GMT+7)",
    "goRecharge": "Tới Trang Nạp",
    "rewards": {
      "goRecharge": "Tới Trang Nạp",
      "record": "Lịch Sử",
      "rewardsAll": "Nhận Thưởng",
      "rewardTimes": "Số lần còn lại:",
      "btnStatus": {
        "canReceive": "Có thể nhận",
        "received": "Đã nhận",
        "goRecharge": "Tới Trang Nạp"
      },
      "recordTable": {
        "name": "Gói nạp",
        "details": "Chi tiết phần thưởng",
        "time": "Thời gian nhận"
      }
    },
    "rule": {
      "title": "Chi tiết sự kiện:",
      "content": "1. Cách nạp: Truy cập [goRecharge].và nạp đúng các mốc như quy định của sự kiện. **Lưu ý: Nếu không nạp đúng mốc, sẽ không nhận được thưởng!\n2. Cách thức nhận thưởng: Sau khi nạp đúng mốc thành công, ấn nút [Nhận Thưởng]. Hệ thống sẽ tự động gửi phần thưởng qua Hòm thư, nhớ vào game kiểm tra nhé!\n3. Số lần nhận thưởng: Mỗi mốc nạp có giới hạn số lần nhận thưởng, vui lòng xem chi tiết tại bảng \"Số lần nhận thưởng\" bên dưới. Lưu ý: Phần thưởng chỉ được nhận trong giới hạn số lần nạp quy định."
    },
    "rewardsAllDialog": {
      "content": "Nhận thành công!\nĐể biết chi tiết phần thưởng, xem [Lịch Sử]"
    },
    "rewardsTimes": {
      "times": "lần"
    }
  },
  "accum": {
    "actStartCountDown": "Đếm ngược BẮT ĐẦU Sự kiện",
    "actEndCountDown": "Đếm ngược KẾT THÚC Sự kiện",
    "rewardEndCountDown": "Đếm ngược Nhận Thưởng",
    "actEnded": "Sự kiện đã kết thúc",
    "clickHere": "Tại đây",
    "goRecharge": "Tới trang nạp",
    "record": "Lịch sử",
    "rewardsAll": "Nhận hết",
    "rewards": {
      "eventDesc": "Đến Trang Nạp chính thức[{clickHere}]nạp tích luỹ đạt mốc 100/300/500/1000/2000/3000/5000/10000 sẽ nhận được phần thưởng giá trị!(Chương trình chỉ áp dụng với KCSM được nạp chính thức, không tính KCSM thưởng thêm.)",
      "eventDescDuojin": "Nâng cấp thưởng: Bổ sung thêm thưởng dành cho chế độ mới {duojin}. Nhanh tay tham gia và nhận quà ngay!",
      "duojin": "[Tập Kích Kho Báu]",
      "eventTime": "Thời gian sự kiện: 00:00 12/06/2026 - 23:59 21/06/2026 (GMT+7)",
      "rewardEndTime": "Thời gian nhận thưởng kết thúc vào 23:59 28/06/2026 (GMT+7)",
      "diffDiamond": "Nạp thêm [diamondNum] KCSM để nhận mốc thưởng tiếp theo.",
      "btnCanReceive": "Còn sẵn",
      "btnReceived": "Đã nhận",
      "btnNotReach": "Chưa đạt mốc",
      "canReceiveAll": "Bạn có thể nhận tất cả phần thưởng"
    },
    "rewardsAllDialog": {
      "title": "Chúc mừng bạn nhận thưởng!",
      "content": "Nhận thành công!\nĐể biết chi tiết phần thưởng, xem [record]"
    },
    "recordDialog": {
      "title": "Lịch sử",
      "reachNode": "Lịch sử Nạp",
      "details": "Chi tiết phần thưởng",
      "time": "Thời gian nhận",
      "noData": "Không có dữ liệu"
    },
    "rule": {
      "content": "1. Hướng dẫn Nạp:\nNhấn nút {goRecharge} ở trên để truy cập kênh nạp chính thức, mua ngay KCSM!\n\n2. Cách thức nhận Thưởng:\nKhi tích luỹ nạp đến mốc nhận thưởng, hãy nhấn [Nhận]. Phần thưởng sẽ được gửi qua [Thư] trong game, nhớ vào game để nhận nhé!\n\n3. Giới hạn nhận Thưởng:\nMỗi mốc thưởng chỉ có thể nhận một lần, không thể nhận lần 2.\n\n4. Lưu ý:\nToàn bộ nội dung sự kiện sẽ dựa theo thông tin hiển thị thực tế trên trang sự kiện. Quyền quyết định cuối cùng thuộc về đội ngũ Mini World Royale."
    }
  },
  "cny": {
    "goRecharge": "Tới trang nạp",
    "record": "Lịch sử",
    "remainingTimes": "Lượt quay còn lại",
    "skipAnimation": "Bỏ qua",
    "lotteryOnce": "Quay 1 lần",
    "lotteryOneKey": "Quay nhanh",
    "lottery": {
      "desc": "Nhận 01 lượt quay Vòng Quay May Mắn cho mỗi lần nạp tích lũy 500 KCSM trên kênh nạp chính thức.\n(Lưu ý: Hệ thống chỉ tính số KCSM gốc từ giao dịch nạp, không tính KCSM khuyến mãi.)",
      "times": "Thời gian nạp hợp lệ: Từ 00:00 ngày 24/12/2025 đến 23:59 ngày 12/01/2026 (GMT+7)\nThời gian nhận thưởng: Từ 00:00 ngày 24/12 đến 23:59 ngày 18/01/2026 (GMT+7)"
    },
    "lotteryRewardDialog": {
      "title": "Chúc mừng bạn nhận thưởng!"
    },
    "rewards": {
      "desc": "Nhận [Rương Tiến Trình] tương ứng với mốc tích lũy 2, 5, 10, 20, 30 và 50 lượt quay tại trang sự kiện.",
      "times": "Thời gian nạp hợp lệ: Từ 00:00 ngày 22/12/2025 đến 00:59 ngày 12/01/2026 (GMT+7)\nThời gian nhận thưởng: Từ 00:00 ngày 22/12 đến 23:59 ngày 18/01/2026 (GMT+7)",
      "lotteryNTimes": "Quay {times} lần",
      "reachNode": "Mốc thưởng",
      "rewardsAllDialog": {
        "content": "Nhận thành công!\nĐể biết chi tiết phần thưởng, xem [Lịch sử]"
      }
    },
    "rule": {
      "content": "1. Nhận 01 lượt quay Vòng Quay May Mắn cho mỗi lần nạp tích lũy 500 KCSM trên kênh nạp chính thức. (Lưu ý: Hệ thống chỉ tính số KCSM gốc từ giao dịch nạp, không tính KCSM khuyến mãi.)\n2. Nhận [Rương Tiến Trình] tương ứng với mốc tích lũy 2, 5, 10, 20, 30 và 50 lượt quay tại trang sự kiện.\n3.Thời gian nạp hợp lệ: Từ 00:00 ngày 24/12/2025 đến 23:59 ngày 12/01/2026 (GMT+7)\tThời gian nhận thưởng: Từ 00:00 ngày 24/12 đến 23:59 ngày 18/01/2026 (GMT+7)\n4. Quyết định của đội ngũ chính thức là cuối cùng và không thể bị tranh cãi."
    }
  },
  "mwr": {
    "actTimeDialogText": "Sự kiện sẽ chính thức ra mắt vào lúc 00:00 13/02（GMT+7）. Cùng chờ đón nhé!",
    "actTimeDialogText2": "",
    "save": "Lưu",
    "share": "Chia sẻ",
    "mission": {
      "receiveRewardSuccess": "Nhận thưởng thành công",
      "header": "Nhiệm vụ",
      "progress": "Tiến trình",
      "btns": {
        "canReceive": "Nhận",
        "received": "Hoàn thành",
        "notReach": "Chưa đạt",
        "shareImmediate": "Chia sẻ ngay"
      },
      "list": {
        "1": {
          "key": "dailyLogin",
          "title": "Đăng nhập hàng ngày nhận Thưởng Miễn Phí",
          "desc": "Hàng ngày"
        },
        "2": {
          "key": "loginDaysGt3",
          "title": "Đăng nhập liên tục 3 ngày",
          "desc": "Nhiệm vụ 1 lần"
        },
        "3": {
          "key": "loginDaysGt7",
          "title": "Đăng nhập liên tục 7 ngày",
          "desc": "Nhiệm vụ 1 lần"
        },
        "4": {
          "key": "shareMwr",
          "title": "Chia sẻ Danh hiệu/Wrap lên MXH",
          "desc": "Nhiệm vụ 1 lần"
        },
        "5": {
          "key": "playedFiveNewMode",
          "title": "Chơi 3 chế độ khác nhau",
          "desc": "Hàng ngày"
        },
        "6": {
          "key": "playedFiveNewMode",
          "title": "Chơi [Đấu Trường Thủ Lĩnh] 5 lần",
          "desc": "Nhiệm vụ 1 lần"
        }
      }
    },
    "turn": "Lượt tấn công",
    "turnNum": "Lượt tấn công+{num}lượt",
    "logout": "Đăng xuất",
    "home": {
      "statsPage": {
        "text": "Sổ\nChiến\nTích",
        "btnText": "Xem"
      },
      "dragonPage": {
        "text": "Đại Chiến\nHắc Long",
        "btnText": "Đi"
      }
    },
    "dragon": {
      "noTurn": "Hết lượt bắn",
      "serverProgress": "Tiến trình toàn server",
      "treasureBox": {
        "notReach": "Chưa đạt",
        "received": "Hoàn thành"
      },
      "rule": "Tất cả anh chị em Xạ thủ, cùng chiến đấu đánh bại Hắc Long nào!\n1. Mỗi lượt bắn Hắc Long yêu cầu 1 [Lượt Bắn]\n2. Hoàn thành nhiệm vụ yêu cầu để nhận [Lượt Bắn] \n3. Tổng sát thương gây ra lên Hắc Long đạt các mốc [4.052], [10.130] và [20.260] sẽ mở khoá các Rương Tiến Trình tương ứng. Anh chị em nhớ vào nhận quà nhé!\n4. Khi mở rương, Xạ thủ có cơ hội mở được Rương Siêu Hiếm. Phần thưởng của Rương Siêu Hiếm sẽ thay thế trực tiếp phần thưởng của Rương Tiến Trình chưa nhận.\n5. Tỷ lệ mở Rương Siêu Hiếm [19.999 Kim Cương Vàng]: 0,001%\n6. Sau khi Hắc Long bị đánh bại, toàn server sẽ nhận phần thưởng qua [Thư].\n\nCÂU HỎI THƯỜNG GẶP (FAQ)\n1. Thời gian sự kiện?\nThời gian SK: 00:00 09/02 - 23:59 01/03\nThời gian nhận thưởng: 00:00 09/02 - 23:59 08/03\n\n2. Cách thức nhận quà?\nTất cả quà trong sự kiện sẽ được gửi qua [Thư] trong game, nhớ kiểm tra thường xuyên để không bỏ lỡ nhé!\n\n3. Cách lưu ảnh Chiến tích?\nChọn nút [Save] ở góc dưới bên phải của trang để tạo ảnh Chiến tích. Ấn và giữ hình để lưu ảnh về điện thoại.\n\n4. Có thể tiếp tục tham gia SK sau khi Hắc Long bị hạ gục không?\nSau khi Hắc Long bị hạ gục, Xạ thủ không thể tiếp tục tham gia SK và nhận Rương Tiến Trình. Vậy nên, hãy nhớ tham gia SK đúng lúc nhé!\n\n5. Có thể nhận thưởng mốc nạp nhiều lần không?\nMỗi phần thưởng mốc tiến trình nạp chỉ có thể nhận một lần và không thể nhận lại.\n\n6. Số [Lượt Bắn] của tôi không tăng dù đã hoàn thành nhiệm vụ hàng ngày?\nSau khi hoàn thành nhiệm vụ, hệ thống sẽ xác thực kết quả trong 30s. Sau thời gian này, Xạ thủ sẽ nhận được [Lượt Bắn].\n\n7. Nếu tôi không nhận thưởng trong thời gian nhận quà thì sao?\nVui lòng nhận toàn bộ phần thưởng trước thờ gian kết thúc nhận là 23:59 01/03. Toàn bộ phần thưởng sẽ bị huỷ và không thể nhận sau thời gian này.\n\n8. Cách thức liên hệ CSKH?\nVui lòng liên hệ đến email ministarcustomerservice{'@'}gmail.com kèm UID và thời gian nhận thưởng, đội ngũ CSKH sẽ hỗ trợ bạn sớm nhất có thể。\n",
      "boxRecord": {
        "title": "Lịch sử nhận Thưởng",
        "box": "Rương",
        "reward": "Thưởng",
        "time": "Ngày nhận",
        "box1Name": "Rương Lv I",
        "box2Name": "Rương Lv II",
        "box3Name": "Rương Lv III"
      },
      "superBox": {
        "text1": "Hắc Long gục ngã rồi!",
        "text2": "Quà toàn server đã được gửi trong mail ingame, Xạ thủ vào nhận ngay nhé!",
        "text3": "Chúc Xạ thủ một năm mới vui vẻ!"
      }
    },
    "stats": {
      "infos": {
        "page-1-left-title": "Sổ Chiến Tích",
        "page-1-left-desc": "Xạ Thủ",
        "page-1-right-title": "2025 TÔI ĐÃ ĐẠT",
        "page-2-left-title": "DẤU ẤN CHINH CHIẾN",
        "page-2-right-title": "ĐẠI SẢNH THÀNH TÍCH",
        "totalGameTime": "Tổng thời gian chơi",
        "totalKillCount": "Số mạng hạ gục",
        "alwaysPlayMode": "Chế độ chơi nhiều nhất ",
        "maxRankScore": "Hạng cao nhất",
        "maxWeaponId": "Vũ khí sử dụng nhiều nhất",
        "maxLongWinningCount": "Chuỗi thắng dài nhất",
        "maxLongLoginDays": "Chuỗi đăng nhập dài nhất",
        "topFriendId": "Đồng đội thân nhất",
        "totalWeaponCount": "Số vũ khí đã sở hữu",
        "totalAvtCount": "Số nhân vật và DIY đã sở hữu",
        "modeType-1": "Xếp hạng Thần Súng",
        "modeType-2": "Đảo Sinh Tồn",
        "modeType-3": "Xếp hạng Dã Nhân",
        "hour": "giờ",
        "day": "Ngày"
      },
      "chenghao": {
        "isForty": "Thách Thức Tử Thần",
        "isTwenty": "Cao Thủ Tiêu Diệt",
        "isGame100": "Đẳng Cấp Thế Giới",
        "modeID-1": "Thần Súng - Bậc Thầy Chiến Thuật",
        "modeID-2": "Đảo Sinh Tồn - Kẻ Sống Sót Cuối Cùng",
        "modeID-3": "Dã Nhân - Kẻ Huỷ Diệt",
        "weaponType-1": "SCAR - Sấy Cực Khô",
        "weaponType-2": "DMR - Tuyệt Đối Chính Xác",
        "weaponType-3": "SR - Này Thì Núp!",
        "weaponType-4": "MG hạng nhẹ - Chẳng Cần Ghìm Tâm",
        "weaponType-5": "SMG - Ngộp Không Chú Em?",
        "weaponType-6": "Shotgun - Bắn Hay Như Hack",
        "weaponType-7": "MG hạng nặng - Vua Xả Đạn",
        "weaponType-8": "Cận chiến - Bàn Tay của Thần",
        "is10WValue": "Tiên phong Phong cách",
        "is15WValue": "Fashionista",
        "is20WValue": "Biểu tượng Thời Trang"
      },
      "chenghaoDesc": {
        "isForty": "Top 40% Xạ thủ có tỷ lệ hạ gục cao nhất",
        "isTwenty": "Top 20% Xạ thủ có tỷ lệ hạ gục cao nhất",
        "isGame100": "Top 100 tất cả các Chế độ Xếp hạng",
        "modeID-1": "Chế độ chơi nhiều nhất",
        "modeID-2": "Chế độ chơi nhiều nhất",
        "modeID-3": "Chế độ chơi nhiều nhất",
        "weaponType-1": "Vũ khí sử dụng nhiều nhất",
        "weaponType-2": "Vũ khí sử dụng nhiều nhất",
        "weaponType-3": "Vũ khí sử dụng nhiều nhất",
        "weaponType-4": "Vũ khí sử dụng nhiều nhất",
        "weaponType-5": "Vũ khí sử dụng nhiều nhất",
        "weaponType-6": "Vũ khí sử dụng nhiều nhất",
        "weaponType-7": "Vũ khí sử dụng nhiều nhất",
        "weaponType-8": "Vũ khí sử dụng nhiều nhất",
        "is10WValue": "Điểm sành điệu trên 100,000",
        "is15WValue": "Điểm sành điệu trên 150,000",
        "is20WValue": "Điểm sành điệu trên 200,000"
      }
    }
  },
  "sf": {
    "endCountdown": "Đếm ngược đến khi SK kết thúc",
    "startCountdown": "Đếm ngược đến khi SK bắt đầu",
    "ended": "Sự kiện đã kết thúc, bạn nhớ nhận Thưởng đúng hạn nhé!",
    "notStart": "Sự kiện chưa bắt đầu.",
    "day": "Ngày",
    "lottery": {
      "desc": "Trong thời gian SK: \n1. Mỗi lần nạp 100 KCSM trên web nạp chính thức sẽ nhận được 1 [Pháo hoa] miễn phí.\n2. Mỗi lần đốt [Pháo hoa] sẽ nhận được phần thưởng ngẫu nhiên. Đốt nhiều lần có thể mở rương thưởng tương ứng với mốc tiến trình.\n3. Lưu ý: Hệ thống chỉ tính số KCSM gốc từ giao dịch nạp, không tính KCSM khuyến mãi. Hãy theo dõi tiến trình SK dựa trên số KCSM gốc đã nạp để đảm bảo chính xác nhé!",
      "times": "Thời gian nạp hợp lệ: Từ 00:00 ngày 09/02/2026 đến 23:59 ngày 01/03/2026 (GMT+7)\nThời gian nhận thưởng: Từ 00:00 ngày 09/02 đến 23:59 ngày 09/03/2026 (GMT+7)",
      "remainingTimes": "Lượt đốt còn lại",
      "skipAnimation": "Không xem bắn Pháo Hoa"
    },
    "lotteryOnce": "Đốt 1 lần",
    "lotteryOneKey": "Đốt tất cả",
    "rewards": {
      "canReceiveAll": "Bạn có thể nhận tất cả phần thưởng",
      "diffDiamond": "Cần [diamondNum] [Pháo hoa] để nhận mốc thưởng tiếp theo",
      "lotteryNTimes": "{times}lần"
    },
    "rule": {
      "content": "Trong thời gian SK: \n1. Mỗi lần nạp 100 KCSM trên web nạp chính thức sẽ nhận được 1 [Pháo hoa] miễn phí.\n2. Mỗi lần đốt [Pháo hoa] sẽ nhận được phần thưởng ngẫu nhiên. Đốt nhiều lần có thể mở rương thưởng tương ứng với mốc tiến trình.\n3. Lưu ý: Hệ thống chỉ tính số KCSM gốc từ giao dịch nạp, không tính KCSM khuyến mãi. Hãy theo dõi tiến trình SK dựa trên số KCSM gốc đã nạp để đảm bảo chính xác nhé!"
    }
  },
  "wc2026": {
    "login": {
      "logintxt": "Đăng Nhập",
      "inputCode": "Nhập mã xác minh",
      "sendCode": "Gửi mã qua [Thư]",
      "submit": "Xác nhận",
      "cancel": "Huỷ",
      "codeSent": "Đã gửi mã xác thực, vui lòng kiểm tra [Thư]",
      "loginSuccess": "Đăng nhập thành công",
      "codeError": "Đăng nhập lỗi",
      "emailPlaceholder": "Vui lòng nhập tài khoản",
      "codePlaceholder": "Vui lòng nhập mã xác minh"
    },
    "logout": "[Đăng Xuất]",
    "intro": {
      "title": "Giới thiệu Sự kiện",
      "contentText": "Cổ Vũ World Cup: Chọn đội tuyển bạn yêu thích để nhận nhiều phần thưởng hấp dẫn!\r\nHoàn thành nhiệm vụ hằng ngày để nhận [Lượt Cổ Vũ] và cổ vũ cho đội tuyển bạn yêu thích tại trang lịch thi đấu. Kỳ World Cup lần này có 48 đội tuyển với lịch thi đấu kéo dài 39 ngày. Cổ vũ càng nhiều trận, bạn càng mở khóa được nhiều mốc thưởng và quà BXH giá trị.\r\nĐăng nhập mỗi ngày, hoàn thành nhiệm vụ và tiếp tục cổ vũ để đồng hành cùng đội tuyển bạn yêu thích đến trận cuối cùng!"
    },
    "tabs": {
      "rewardHistory": "Lịch Sử Nhận Thưởng",
      "cheerCountLabel": "Lượt Cổ Vũ:",
      "goEarn": "Đến Nhận",
      "cheerPowCash": "Tiếp Sức Cuồng Nhiệt",
      "toCheer": "Đội Tuyển Cổ Vũ"
    },
    "rank": {
      "title": "BXH Cao Thủ Cổ Vũ",
      "rank": "Xếp Hạng",
      "nickname": "Tên Nhân Vật",
      "winCount": "Số Trận Thắng",
      "awardDes": "Top 50 người chơi có tổng số trận Cổ Vũ cao nhất sẽ nhận được Khung Avatar và Danh hiệu độc quyền qua [Thư].",
      "des2": "Hạng 4–10: 700 Kim Cương Vàng , Hạng 11–25: 400 Kim Cương Vàng , Hạng 26–50: 200 Kim Cương Vàng.",
      "des1": "Hạng 1: 2000 Kim Cương Vàng , Hạng 2: 1500 Kim Cương Vàng , Hạng 3: 1000 Kim Cương Vàng;"
    },
    "accountId": "ID Tài Khoản",
    "noData": "Chưa có dữ liệu",
    "reaawardName": "Tên Phần Thưởng",
    "cheerTime": "Số lần cổ vũ thành công",
    "times": "Lần",
    "bet": {
      "matchResult": {
        "pending": "Trận đấu chưa bắt đầu",
        "cheered": "Đã cổ vũ",
        "draw": "Trận đấu bị hủy",
        "win": "_team Thắng",
        "daping": "Hòa",
        "running": "Trận đấu đang diễn ra"
      },
      "selectDate": "Lịch thi đấu",
      "noMatches": "Không có trận đấu",
      "cheerSuccess": "Cổ vũ thành công",
      "confirm": {
        "content": "Xác nhận cổ vũ"
      }
    },
    "backTop": "Quay lại đầu trang",
    "milestone,mainTitle": "Cổ Vũ Nhận Quà Khủng",
    "milestone": {
      "totalCheer": "Thưởng mốc cổ vũ",
      "winCheer": "Thưởng Tiến Độ",
      "subTitleTotal": "Tích luỹ tổng số Trận Cổ Vũ theo yêu cầu để nhận thưởng tương ứng, dự đoán đúng nhiều - quà càng hấp dẫn!",
      "subTitleWin": "Tích luỹ đạt mốc số lần cổ vũ thành công để nhận thưởng tương ứng, dự đoán đúng càng nhiều quà càng hấp dẫn!",
      "betTarget": "_n lần",
      "title1": "Cổ vũ_N_lần",
      "title2": "Cổ vũ_thành công_N_lần"
    },
    "betTarget": "5 lần",
    "received": "Đã nhận",
    "canReceive": "Mở khoá",
    "notReach": "Khoá",
    "rule": {
      "title": "Quy tắc Sự kiện",
      "content": "1. Hướng dẫn tham gia\r\nTrong mỗi trận đấu, thông tin về quốc kỳ và tên của hai đội sẽ được hiển thị. Người chơi chọn một đội để gửi lượt cổ vũ. Mỗi người chơi chỉ được cổ vũ tối đa 1 lần cho mỗi trận. Sau khi xác nhận, lượt cổ vũ sẽ bị trừ ngay lập tức và không thể thay đổi hoặc thu hồi.\r\nThời gian cổ vũ bắt đầu sớm nhất trước 2 ngày khi trận đấu diễn ra. Sau khi trận đấu chính thức bắt đầu, hệ thống sẽ đóng tính năng cổ vũ cho trận đấu đó.\r\nĐối với giai đoạn vòng loại trực tiếp, quy tắc chọn đội vẫn áp dụng tương tự như vòng bảng, nhưng sẽ không có tùy chọn kết quả hòa.\r\n\r\n2. Kết quả và Phần thưởng\r\nNếu đội bạn chọn giành chiến thắng, bạn sẽ nhận được các vật phẩm trong game. Nếu trận đấu kết thúc với tỷ số hòa (chỉ áp dụng ở vòng bảng), người chơi cổ vũ cho cả hai đội đều sẽ nhận được phần thưởng.\r\nKết quả cổ vũ cuối cùng sẽ dựa trên kết quả chính thức của trận đấu.\r\nKhi đạt đủ số trận cổ vũ theo các mốc quy định, bạn sẽ nhận được phần thưởng tích lũy tương ứng. Số lần cổ vũ thành công sẽ được dùng để xếp hạng trên bảng vinh danh.\r\n\r\n3. Lưu ý quan trọng\r\nHủy hoặc hoãn trận đấu: Nếu trận đấu bị hủy, hoãn hoặc bị hủy bỏ kết quả vì bất kỳ lý do gì, lượt cổ vũ của tất cả người chơi sẽ được hoàn trả toàn bộ và không tính vào kết quả chung.\r\nXử lý gian lận: Nếu phát hiện các hành vi gian lận lượt cổ vũ hoặc lợi dụng lỗi game để trục lợi, hệ thống sẽ tiến hành thu hồi lượt cổ vũ bất thường và áp dụng các biện pháp xử phạt nghiêm khắc, bao gồm cả khóa tài khoản.\r\nTrong mọi trường hợp, Đội ngũ Mini World Royale giữ quyền quyết định cuối cùng."
    },
    "record": {
      "matchTime": "Trận Đấu",
      "rewards": "Phần Thưởng",
      "cheerTime": "Thời Gian Cổ Vũ",
      "cheerWinTab": "Phần thưởng cổ vũ",
      "milestoneTab": "Phần thưởng mốc",
      "milestone": "Mốc thưởng",
      "receiveTime": "Thời gian nhận",
      "target": "Mục tiêu: "
    },
    "share": {
      "text": "Chia sẻ",
      "title": "Cổ vũ thành công _n_ trận và nhận thưởng ⚽",
      "description": "Chơi bằng đầu, thắng bằng trình!"
    },
    "mail": {
      "title": "[Tiếp Sức Cuồng Nhiệt] Chúc mừng dự đoán chiến thắng!",
      "content": "Xạ thủ thân mến,\r\n\r\nChúc mừng bạn đã dự đoán chính xác chiến thắng của đội tuyển bạn lựa chọn trong SK [Tiếp Sức Bùng Nổ]! Phần thưởng cổ vũ cho trận đấu này đã được gửi vào tài khoản của bạn, vui lòng kiểm tra.\r\n\r\nChúc Xạ thủ có những phút giây vui vẻ trong sự kiện!\r\n\r\nĐội ngũ Mini World Royale"
    },
    "item": {
      "id_70100004": "Thẻ nâng cấp VK Lv.3",
      "id_70100101": "Kim Cương Vàng",
      "id_80102101": "Vé quay Kim Cương Vàng",
      "id_70100011": "Xu Vàng",
      "id_32204003": "Hòm An Toàn Trung cấp (7 ngày)",
      "id_70100014": "Chìa Khoá Bí Bảo",
      "id_81010999": "Xu tăng trưởng Đa năng",
      "id_90501207": "Danh hiệu",
      "id_90301905": "Khung Avatar",
      "id_90105303": "Avatar",
      "id_20500901": "Tâm ngắm - Bóng Đá",
      "id_20400904": "Móc treo - Còi Trọng Tài",
      "id_90301906": "Khung Avatar",
      "id_90501208": "Danh hiệu",
      "code429": "Yêu cầu quá nhiều, vui lòng thử lại sau"
    },
    "task": {
      "wc_daily_login": "Đăng nhập mỗi ngày",
      "wc_daily_play_mojin1": "Chơi 1 trận TKKB",
      "wc_daily_play_mojin3": "Chơi 3 trận TKKB",
      "wc_daily_play_any3": "Chơi 3 trận bất kỳ",
      "wc_daily_online_60m": "Online đủ 60p",
      "wc_weekly_share": "Chia sẻ Danh Hiệu lên MXH",
      "daily": "Nhiệm vụ hàng ngày",
      "weekly": "Nhiệm vụ Tuần"
    },
    "receiveSuccess": "Nhận thành công",
    "error": {
      "code1104": "Thời gian Cổ Vũ đã kết thúc",
      "code1105": "Đã Cổ Vũ cho trận đấu này",
      "code1106": "Không đủ lượt Cổ Vũ",
      "code1202": "Phần thưởng đã nhận",
      "code1203": "Nhiệm vụ chưa hoàn thành",
      "code1302": "Đã nhận mốc thưởng",
      "code1303": "Chưa đạt điều kiện mốc thưởng",
      "code1401": "Chia sẻ quá nhiều lần",
      "code13404": "Đã đạt giới hạn số lần nhận mã xác thực hôm nay",
      "code13405": "Mã xác thực đã hết hạn hoặc không tồn tại",
      "code13406": "Số lần xác thực quá giới hạn, thử lại vào ngày mai/ liên hệ CSKH",
      "code501": "Thất bại, user không tồn tại",
      "code11402": "การเข้าสู่ระบบหมดอายุ"
    },
    "mailveritify_success": "Thành công"
  },
  "monopoly": {
    "rule": "Thể Lệ Sự Kiện",
    "ruleContent": "1. Sự kiện kéo dài từ 00:00 15/08 đến 23:59 30/08 (GMT+7). Sau khi sự kiện kết thúc sẽ không thể nhận thêm Xúc xắc thông qua việc nạp KCSM, và vẫn có thể tiếp tục sử dụng Xúc Xắc còn lại trong tài khoản. Sau 00:00 ngày 7/9 (GMT+7), người chơi sẽ không thể sử dụng số Xúc xắc còn dư, đồng thời hệ thống sẽ tiến hành tổng kết và phát thưởng xếp hạng.\nTrang sự kiện sẽ được đóng hoàn toàn vào lúc 00:00 ngày 14/9 (GMT+7).\n2. Trong thời gian diễn ra sự kiện, mỗi ngày đăng nhập vào trang sự kiện sẽ được nhận miễn phí 1 Xúc Xắc Thường (tối đa 3 xúc xắc trong suốt sự kiện).\n3. Cứ nạp mỗi 100 Kim Cương Sắc Màu sẽ nhận được 1 Xúc Xắc Thường. Với mỗi 1,000 Kim Cương Sắc Màu tích lũy sẽ được tặng thêm 1 Xúc Xắc Vạn Năng.\n4. Khi sử dụng Xúc Xắc Thường, bạn sẽ nhận được ngẫu nhiên từ 1 đến 6 bước.\n5. Xúc Xắc Vạn Năng tự chọn số nút mong muốn từ 1 đến 6 trước khi nhân vật di chuyển.\n6. Bản đồ bao gồm tổng cộng 24 ô. Sau khi hoàn thành một vòng, bạn sẽ tiếp tục xuất phát lại từ ô Khởi Hành (Start) và hệ thống sẽ tự động ghi nhận tích lũy số vòng của bạn.\n7. Khi dừng lại ở các ô khác nhau, bạn sẽ nhận được những phần thưởng tương ứng. Một số ô đặc biệt sẽ kích hoạt sự kiện đặc biệt, vui lòng theo dõi thực tế trong trò chơi.\n8. Đạt các mốc số vòng quy định để nhận thêm phần thưởng mốc. Đi được càng nhiều vòng, quà mở khóa càng giá trị.\n9. Quà xếp hạng sẽ được tổng kết và trao dựa trên Bảng Xếp Hạng Số Vòng cuối cùng sau khi sự kiện kết thúc. Hãy nhớ nhận thưởng trước khi sự kiện hết hạn.\n10. Tất cả phần thưởng trên bàn cờ sẽ được gửi vào Hộp thư trong game sau khi bạn nhấn nút Nhận Thưởng. Các phần thưởng chưa nhận sẽ không thể cấp lại sau khi sự kiện kết thúc.",
    "rewardRecord": "Lịch Sử Nhận Thưởng",
    "rewardRecordDialog": {
      "reward": "Phần Thưởng",
      "time": "Thời Gian Nhận",
      "status": "Trạng Thái",
      "statusPending": "Chưa Nhận",
      "statusExtracted": "Đã Nhận",
      "statusSent": "Đã gửi",
      "empty": "Không có dữ liệu"
    },
    "mainRule": "Đăng nhập mỗi ngày để nhận 1 Xúc Xắc miễn phí (tối đa 3 lượt suốt sự kiện)\nMỗi lần nạp 100 Kim Cương Sắc Màu nhận thêm 1 Xúc Xắc.\nNạp đủ 1000 Kim Cương Sắc Màu nhận ngay 1 Xúc Xắc Vạn Năng!",
    "logout": "Đăng Xuất",
    "loginTitle": "Xác Minh Nhân Vật",
    "accountId": "ID Nhân vật",
    "login": {
      "logintxt": "[Đăng nhập]",
      "inputCode": "Nhập Mã Xác Minh",
      "sendCode": "Gửi Mã",
      "submit": "Xác nhận",
      "cancel": "Huỷ",
      "codeSent": "Đã gửi mã xác thực, vui lòng kiểm tra [Thư]",
      "loginSuccess": "Đăng nhập thành công",
      "codeError": "Đăng nhập lỗi",
      "emailPlaceholder": "Vui lòng nhập tài khoản",
      "codePlaceholder": "Nhập Mã Xác Minh"
    },
    "normalDiceNum": "Xúc Xắc Còn Lại: {num}",
    "universalDiceNum": "Xúc Xắc Vạn Năng Còn Lại: {num}",
    "throwOnce": "Gieo 1 Lần",
    "throwAll": "Gieo Tất Cả",
    "pleaseLogin": "Vui lòng đăng nhập trước",
    "noDiceTitle": "Bạn đã hết lượt đổ Xúc Xắc",
    "noDiceTip1": "Mỗi lần nạp {amount} Kim Cương Sắc Màu nhận thêm 1 {dice}.",
    "noDiceTip2": "Nạp đủ {amount} Kim Cương Sắc Màu nhận ngay 1 {dice}!",
    "noDiceNormal": "Xúc Xắc",
    "noDiceUniversal": "Xúc Xắc Vạn Năng",
    "noDiceGoRecharge": "Tới trang nạp",
    "chooseStepsTitle": "Chọn Số Lượng Xúc Xắc Vạn Năng",
    "chooseStepsOption": "Tiến lên {steps} Ô",
    "chooseStepsConfirm": "Xác Nhận",
    "throwResultUnit": "{steps} nút",
    "throwAllRewardTip": "Bạn đã dùng hết Xúc Xắc (đi {steps} ô). Phần Thưởng Đã Nhận",
    "rewardTitle": "Xin Chúc Mừng! Bạn Đã Nhận Được",
    "rewardEmpty": "Lần này không có phần thưởng",
    "mysteryEmptyTitle": "Đã sở hữu Nhân Vật Giới Hạn, tự động đổi thành Rương Hiếm.",
    "boxRewardTitleNormal": "Thưởng Rương Hiếm",
    "boxRewardTitleLucky": "Thưởng Rương Cao Cấp",
    "boxRewardTitleMystery": "Thưởng Độc Quyền Kỷ Niệm",
    "confirm": "Xác Nhận",
    "dailyDiceClaimSuccess": "Xúc Xắc Thường +1",
    "dailyDiceTipPrefix": "Đăng nhập mỗi ngày để nhận 1 Xúc Xắc miễn phí. (Tối đa ",
    "dailyDiceTipSuffix": " lượt suốt sự kiện).",
    "dailyDiceRemainPrefix": "Số Lần Nhận Còn Lại:",
    "dailyDiceClaim": "Nhận",
    "extractRewards": "Nhận Thưởng",
    "extractRewardsDesc": "Nhấn nút để Nhận tất cả phần thưởng qua Hộp thư ingame",
    "extractSuccessTitle": "Phần thưởng đã gửi vào Hộp thư trong game",
    "noPendingRewards": "Không có phần thưởng để nhận",
    "circleRewards": "Hoàn thành thêm vòng để mờ khoá thêm phần thưởng!",
    "circleAccumulated": "Tổng Số Vòng: {count}",
    "circleLaps": "{count} Vòng",
    "lapRewardAlready": "Phần thưởng đã nhận",
    "lapRewardNotReached": "Chưa đạt số vòng yêu cầu",
    "ranking": "BXH Số Vòng",
    "rankingTable": {
      "rank": "Hạng",
      "nickname": "Tên Nhân Vật",
      "laps": "Số Vòng",
      "time": "Thời gian đạt (GMT+7)"
    },
    "rankingEmptyNickname": "Đang trống",
    "rankingRewardTitleSingle": "Thưởng Hạng {rank}",
    "rankingRewardTitleRange": "Thưởng Hạng {min}-{max}",
    "moveSteps": "Tiến lên {steps} Ô",
    "moveStepsBack": "Lùi {steps} Ô",
    "moveStepsCastle": "Ô Lâu Đài Kỷ Niệm: đến ô {steps}",
    "notStart": "Sự kiện chưa bắt đầu.",
    "ended": "Sự kiện đã kết thúc, bạn nhớ nhận Thưởng đúng hạn nhé!",
    "startCountdown": "Đếm ngược đến khi SK bắt đầu",
    "rechargeCountDown": "Nạp nhận thêm Xúc Xắc còn",
    "diceCountDown": "Thời hạn sử dụng Xúc Xắc còn",
    "countDownNotStarted": "Chưa bắt đầu",
    "countDownEnded": "Kết thúc",
    "day": "Ngày",
    "error": {
      "code401": "Phiên đăng nhập hết hạn",
      "code429": "Yêu cầu quá nhiều, vui lòng thử lại sau",
      "code2001": "Sự kiện chưa bắt đầu",
      "code2002": "Sự kiện đã kết thúc",
      "code2003": "Thời gian nhận thưởng đã kết thúc",
      "code2004": "Sự kiện đã kết thúc",
      "code2801": "Đã nhận xúc xắc hôm nay",
      "code2802": "Đã đạt giới hạn nhận xúc xắc hàng ngày",
      "code2803": "Hiện không thể nhận xúc xắc hàng ngày",
      "code2901": "Bạn đã hết lượt đổ Xúc Xắc",
      "code2902": "Loại xúc xắc không hợp lệ",
      "code2903": "Số bước chọn không hợp lệ",
      "code2904": "Xúc xắc Vạn Năng không hỗ trợ tung tất cả",
      "code3001": "Không có phần thưởng để nhận",
      "code3002": "Nhận thất bại, vui lòng thử lại sau",
      "code3101": "Chưa đạt số vòng yêu cầu",
      "code3102": "Phần thưởng đã nhận",
      "code3201": "BXH chưa được chốt",
      "code3202": "Phần thưởng xếp hạng đã gửi"
    }
  },
  "ann2026": {
    "title": "Anniversary Ignite Plan",
    "flamePower": "Điểm Hỏa Lực",
    "item": {
      "70100004": "Vé Điểm",
      "80102101": "Vé quay Kim Cương Vàng",
      "70100011": "Xu Vàng",
      "70100014": "Chìa Khoá Bí Bảo",
      "70100013": "Vé Bí Bảo",
      "10101404": "AN94 Quế Hoa",
      "50111700": "Thánh Vân Chi",
      "80103001": "Thẻ Bảo Vệ Xếp Hạng",
      "1010102006": "M4-Xuất Kích Đáng Yêu",
      "32701006": "Gói trang bị cao cấp",
      "90301910": "[Khung Avatar] Sinh Nhật",
      "90301911": "[Khung Avatar]Bão Lửa Rực Cháy",
      "90501244": "【Danh hiệu】 Ngọn Lửa Vĩnh Hằng",
      "90501245": "【Danh hiệu】 Từ Đống Tro Tàn",
      "81010999": "Xu tăng trưởng Đa năng",
      "TBD_avatar_frame": "[Khung Avatar] Sinh Nhật",
      "TBD_title": "Chúc mừng Sinh nhật",
      "TBD_pendant": "Móc treo - Còi Trọng Tài"
    },
    "home": {
      "serverPower": "Điểm Chung Sức toàn Server"
    },
    "hero": {
      "howToPlay": "Giới thiệu sự kiện",
      "logout": "[Đăng Xuất]",
      "login": "[Đăng Nhập]"
    },
    "contribute": {
      "btnMain": "Đóng Góp Chung Sức",
      "desc1": "Chung sức thắp sáng Bánh Sinh nhật!",
      "desc2": "Điểm Chung Sức: _n",
      "tabSupply": "Tiếp Tế Chung Sức",
      "tabRally": "Xạ Thủ, tập hợp!",
      "tabHistory": "Lịch Sử Nhận Thưởng"
    },
    "dialog": {
      "close": "Đóng"
    },
    "flameSupply": {
      "title": "Tiếp Tế Chung Sức",
      "subtitle": "HOÀN THÀNH NHIỆM VỤ ĐỂ NHẬN SỨC MẠNH",
      "claimed": "Đã nhận",
      "completed": "Mở khoá",
      "incomplete": "Chưa hoàn thành"
    },
    "eliteRally": {
      "subtitle": "MỜI BẠN QUAY LẠI ĐỂ NHẬN THƯỞNG",
      "inviteOne": "Mời 1 người bạn",
      "inviteMany": "Mời {count} người bạn",
      "claimed": "Đã nhận",
      "claim": "Nhận",
      "locked": "Đã khóa",
      "itemName": "Tên vật phẩm"
    },
    "rewardHistory": {
      "title": "Lịch Sử Nhận Thưởng",
      "reward": "PHẦN THƯỞNG",
      "receivedAt": "THỜI GIAN NHẬN"
    },
    "congratulation": {
      "receivedReward": "NHẬN THƯỞNG"
    },
    "howToPlay": {
      "body": "Tiếp Lửa Sinh Nhật - Thắp Nến Kỷ Niệm!\nTrong đêm lễ hội, bè lũ Hắc Ám đã lén thổi tắt nến trên bánh sinh nhật! Tom, Nona và Lăng Vũ kêu gọi toàn bộ anh em cùng chung sức thắp sáng lại \"Ngọn nến số 1\" tượng trưng cho Sinh nhật 1 năm của Mini World Royale!\n\nThời gian sự kiện\nThời gian Chung Sức: 15/08 - 06/09 (GMT+7)\nThời gian đổi thưởng: Từ khi sự kiện bắt đầu đến 13/09 (GMT+7)\nVui lòng nhận thưởng trong thời gian quy định, quá hạn sẽ được coi là tự động từ bỏ.\n\nCách tham gia\nBước 1: Nhận [Lượt Thắp Sáng]\nHoàn thành nhiệm vụ hằng ngày (điểm danh, đấu trận, online đủ xx phút, chia sẻ, ăn Bánh Kem trong Tập Kích Kho Báu) để nhận [Lượt Thắp Sáng]. Nhớ làm mỗi ngày, càng nhiều lượt tích luỹ công góp càng cao!\nBước 2: Chung Sức Thắp Sáng\nDùng lượt thắp sáng để đóng góp vào Thanh tiến độ Chung Sức Toàn Server. Mục tiêu là thắp sáng lại cả ba tầng bánh sinh nhật!\nBước 3: Mở Khóa Phần Thưởng\nPhần thưởng toàn server: Khi tiến độ Chung Sức đóng góp toàn server đạt 25% - 50% - 75% - 100%, tầng bánh tương ứng sẽ được thắp sáng và tất cả người chơi tham gia đều có thể nhận phần thưởng. Khi thanh tiến độ đạt 100% và thắp sáng \"ngọn nến số 1\" trên đỉnh bánh, toàn server sẽ nhận quà đặc biệt cùng [Khung Avatar] và [Danh hiệu kỷ niệm 1 năm] độc quyền.\nThưởng cá nhân: Đóng góp tích lũy [Lượt Thắp Sáng] để mở khóa các mốc thưởng cá nhân. Góp càng nhiều, quà càng ngon!\n\nAnh Em Tề Tựu\nVào mục [Anh Em Tề Tựu] để mời những người bạn lâu ngày chưa quay lại chiến trường trở về. Mời càng nhiều bạn, phần thưởng càng hấp dẫn. Đạt các mốc quy định còn nhận Khung đại diện và Danh hiệu độc quyền. Có bạn cũ trở lại, sinh nhật sẽ càng vui hơn!\n\nLịch sử nhận thưởng\nXem tại mục [Lịch sử nhận thưởng]."
    },
    "powerContributed": {
      "text": "Sức mạnh đã đóng góp: {count}"
    },
    "task": {
      "ann_daily_login": "Đăng nhập mỗi ngày",
      "ann_daily_mojin_1": "Hoàn thành 1 trận TKKB",
      "ann_daily_mojin_3": "Hoàn thành 3 trận TKKB",
      "ann_daily_play_any_1": "Hoàn thành 1 trận ở chế độ bất kỳ",
      "ann_weekly_share": "Chia sẻ lên MXH",
      "ann_weekly_mojin_cake": "[TKKB] Nhận vật phẩm cấp Đỏ: Bánh Kem Kỷ Niệm",
      "dailyLabel": "Nhiệm vụ ngày",
      "weeklyLabel": "Nhiệm vụ tuần"
    },
    "milestone": {
      "times": "_n lần",
      "claim": "Mở khoá",
      "claimed": "Đã nhận",
      "notAchieved": "Khoá",
      "reward_1": "Avatar Frame",
      "reward_2": "10000 card point",
      "reward_3": "2 Golden Diamond Draw Ticket",
      "reward_4": "Title",
      "reward_5": "30 Mystic Voucher",
      "reward_6": "3 Golden Diamond Draw Ticket",
      "reward_7": "6 Million Gold",
      "reward_8": "3 Golden Diamond Draw Ticket",
      "reward_9": "Pendant",
      "reward_10": "1 Mystic Key",
      "reward_11": "AN94"
    },
    "footer": {
      "privacyPolicy": "Chính sách quyền riêng tư",
      "userAgreement": "Thỏa thuận người dùng",
      "customerService": "Vui lòng liên hệ với chúng tôi qua email ministarcustomerservice{'@'}gmail.com"
    },
    "accountId": "Account ID",
    "logout": "Đăng xuất",
    "needLogin": "Please login to participate",
    "phase": "Phase",
    "timeRange": "Play time",
    "availableFire": "Available fire",
    "totalFire": "Total fire",
    "ignite": "Ignite",
    "share": "Chia sẻ",
    "firstLoginReward": "Claim first login reward",
    "refresh": "Refresh",
    "receive": "Nhận",
    "received": "Đã nhận",
    "notReady": "Chưa hoàn thành",
    "unlocked": "Unlocked",
    "locked": "Đã khóa",
    "recallCount": "Recall count",
    "igniteOk": "Ignite success, consumed",
    "shareOk": "Chia sẻ thành công",
    "receiveOk": "Nhận thành công",
    "section": {
      "activity": "Activity info",
      "fire": "My firepower",
      "global": "Global stages",
      "task": "Tasks",
      "milestone": "Milestones",
      "recall": "Recall",
      "record": "Reward records"
    },
    "login": {
      "logintxt": "Đăng Nhập",
      "inputCode": "Nhập mã xác minh",
      "sendCode": "Gửi mã qua [Thư]",
      "submit": "Xác nhận",
      "cancel": "Huỷ",
      "codeSent": "Đã gửi mã xác thực, vui lòng kiểm tra [Thư]",
      "loginSuccess": "Đăng nhập thành công",
      "emailVerificationSuccess": "Thành công",
      "birthday": "Chúc mừng Sinh nhật!!!",
      "codeError": "Đăng nhập lỗi",
      "emailPlaceholder": "Vui lòng nhập tài khoản",
      "codePlaceholder": "Nhập mã xác minh",
      "accountLabel": "ID Tài Khoản",
      "codeLabel": "Mã xác minh"
    },
    "error": {
      "code401": "Phiên đăng nhập hết hạn",
      "code2201": "Nhiệm vụ chưa hoàn thành",
      "code2202": "Phần thưởng đã nhận",
      "code2301": "Chưa đủ Lửa!",
      "code2401": "Chưa mở khoá mốc",
      "code2402": "Phần thưởng đã nhận",
      "code2501": "Chưa đạt điều kiện mốc thưởng",
      "code2502": "Phần thưởng đã nhận",
      "code2601": "Chưa đủ Người Chơi Trở Lại",
      "code2602": "Phần thưởng đã nhận",
      "code2801": "Phần thưởng đã nhận",
      "code2001": "Sự kiện chưa bắt đầu",
      "code2002": "Sự kiện đã kết thúc",
      "code429": "Đã đạt giới hạn..."
    }
  }
}
